import { getStandings } from '@/utils/statScoreApi';
import i18n from '@/utils/i18n.js';

function getForm(team, formId) {
  const form = team.columns.filter(item => item.id === formId);

  return form[0].value ? form : [];
}

let defaultSettingsStandings = [
  {
    key: 'standing',
  },
  {
    key: 'team',
    fill: true,
  },
  {
    key: 'mp',
  },
  {
    key: 'bonus_pts',
  },
  {
    key: 'won',
  },
  {
    key: 'won_ot',
  },
  {
    key: 'won_after_penalty',
  },
  {
    key: 'draw',
  },
  {
    key: 'lost',
  },
  {
    key: 'lost_ot',
  },
  {
    key: 'lost_after_overtime',
  },
  {
    key: 'lost_after_penalty',
  },
  {
    key: 'goal_ratio',
  },
  {
    key: 'points_difference',
  },
  {
    key: 'pts_diff',
  },
  {
    key: 'heats_points_difference',
  },
  {
    key: 'points_ratio',
  },
  {
    key: 'won_pct',
  },
  {
    key: 'pts',
  },
];

let settingsStandings = [];

defaultSettingsStandings.forEach(item => {
  settingsStandings.push(item);
  settingsStandings.push({ ...item, key: 'away_' + item.key });
  settingsStandings.push({ ...item, key: 'home_' + item.key });
  settingsStandings.push({ ...item, key: '1half_' + item.key });
});

const defaultDataSet = {
  columns: [
    {
      key: 'standing',
      center: true,
      bordered: true,
      title: '#',
    },
    {
      key: 'team',
      fill: true,
      title: i18n.t('Props.StatScore.Team'),
    },
    {
      key: 'form',
      inVisibleInMobile: true,
      title: '',
    },
    {
      key: 'P',
      center: true,
      title: 'P',
    },
    {
      key: 'W',
      center: true,
      title: 'W',
    },
    {
      key: 'D',
      center: true,
      title: 'D',
    },
    {
      key: 'L',
      center: true,
      title: 'L',
    },
    {
      key: 'PTS',
      center: true,
      title: 'PTS',
    },
  ],
  dataset: [],
  meta: [],
};

const defaultState = {
  standings: { loading: false, data: [] },
  leagueStandings: [],
  halfStandings: [
    {
      ...JSON.parse(JSON.stringify(defaultDataSet)),
    },
  ],
  homeStandings: {
    ...JSON.parse(JSON.stringify(defaultDataSet)),
  },
  awayStandings: {
    ...JSON.parse(JSON.stringify(defaultDataSet)),
  },
  formStandings: {},
  settingsStandings,
};

const state = {
  ...JSON.parse(JSON.stringify(defaultState)),
};

const getters = {};

const mutations = {
  setLoadingStatus(state, data) {
    state.standings = data.status
      ? { loading: data.status, data: [], error: data.error }
      : { ...state.standings, loading: false, error: data.error };
  },
  setDefaultState(state) {
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key];
    });
  },
  setStandings(state, data) {
    state.standings.data = data;
  },
  setHomeTeamForm(state, data) {
    state.homeTeamForm = data;
  },
  setAwayTeamForm(state, data) {
    state.awayTeamForm = data;
  },
  setHomeTeamFormByHome(state, data) {
    state.homeTeamFormByHome = data;
  },
  setAwayTeamFormByHome(state, data) {
    state.awayTeamFormByHome = data;
  },
  setHomeTeamFormByAway(state, data) {
    state.homeTeamFormByAway = data;
  },
  setAwayTeamFormByAway(state, data) {
    state.awayTeamFormByAway = data;
  },

  setLeagueStandings(state, data) {
    state.leagueStandings = data;
  },
  setLeagueStandingsMeta(state, data) {
    state.leagueStandings.meta = data;
  },
  setHalfStandings(state, data) {
    state.halfStandings = data;
  },
  setHomeStandings(state, data) {
    state.homeStandings = data;
  },
  setAwayStandings(state, data) {
    state.awayStandings = data;
  },
  setFormStandings(state, data) {
    state.formStandings.dataset = data;
  },
};

const actions = {
  getStandings: ({ commit, rootState }, payload) => {
    commit('setDefaultState');
    commit('setLoadingStatus', { status: true });
    return getStandings({
      selectedLang: rootState.settings.selectedLocale.short_code,
      id: payload,
    })
      .then(res => {
        commit('setStandings', res.data.Data);
        //----------------------------FOR STANDINGS DATA-------------------------//
        let leagueStandings = res.data.Data.LeagueStandings
          ? res.data.Data.LeagueStandings.groups.map(item => {
              let teams = item.participants.map(item => {
                let otherInformations = {};
                item.columns.forEach(column => {
                  otherInformations = {
                    ...otherInformations,
                    [column.code]: {
                      title: column.name,
                      short_name: column.short_name,
                      data: { ...column },
                    },
                  };
                });
                return {
                  ...otherInformations,
                  standing: { short_name: '#', value: item.rank },
                  team: {
                    short_name: i18n.t('Props.StatScore.Team'),
                    value: item.name,
                  },
                  zone_name: item.zone_name,
                };
              });
              return {
                ...item,
                teams,
              };
            })
          : [];
        commit('setLeagueStandings', leagueStandings);

        let halfStandings = res.data.Data.HalfTimeStandings
          ? res.data.Data.HalfTimeStandings.groups.map(item => {
              let teams = item.participants.map(item => {
                let otherInformations = {};
                item.columns.forEach(column => {
                  otherInformations = {
                    ...otherInformations,
                    [column.code]: {
                      title: column.name,
                      short_name: column.short_name,
                      data: { ...column },
                    },
                  };
                });
                return {
                  ...otherInformations,
                  standing: { short_name: '#', value: item.rank },
                  team: {
                    short_name: i18n.t('Props.StatScore.Team'),
                    value: item.name,
                  },
                  zone_name: item.zone_name,
                };
              });
              return {
                ...item,
                teams,
              };
            })
          : [];
        commit('setHalfStandings', halfStandings);

        let homeStandings = res.data.Data.HomeStandings
          ? res.data.Data.HomeStandings.groups.map(item => {
              let teams = item.participants.map(item => {
                let otherInformations = {};
                item.columns.forEach(column => {
                  otherInformations = {
                    ...otherInformations,
                    [column.code]: {
                      title: column.name,
                      short_name: column.short_name,
                      data: { ...column },
                    },
                  };
                });
                return {
                  ...otherInformations,
                  standing: { short_name: '#', value: item.rank },
                  team: {
                    short_name: i18n.t('Props.StatScore.Team'),
                    value: item.name,
                  },
                  zone_name: item.zone_name,
                };
              });
              return {
                ...item,
                teams,
              };
            })
          : [];
        commit('setHomeStandings', homeStandings);

        let awayStandings = res.data.Data.AwayStandings
          ? res.data.Data.AwayStandings.groups.map(item => {
              let teams = item.participants.map(item => {
                let otherInformations = {};
                item.columns.forEach(column => {
                  otherInformations = {
                    ...otherInformations,
                    [column.code]: {
                      title: column.name,
                      short_name: column.short_name,
                      data: { ...column },
                    },
                  };
                });
                return {
                  ...otherInformations,
                  standing: { short_name: '#', value: item.rank },
                  team: {
                    short_name: i18n.t('Props.StatScore.Team'),
                    value: item.name,
                  },
                  zone_name: item.zone_name,
                };
              });
              return {
                ...item,
                teams,
              };
            })
          : [];
        commit('setAwayStandings', awayStandings);
        commit('setLoadingStatus', { status: false });
      })
      .catch(err => {
        commit('setLoadingStatus', { status: false, error: true });
        console.log(err);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
